<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Senha definida com sucesso.</h2>
      </div>

      <button
        matButton="filled"
        class="submit-button"
        style="width: 100%"
        (click)="irParaLogin()"
      >
        Acessar
      </button>
      
      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
